
import { defineComponent, PropType } from 'vue';
import T from '../../lang';
import { types } from '../../api_types';

export default defineComponent({
  name: 'Paginator',
  props: {
    pagerItems: {
      type: Array as PropType<types.PageItem[]>,
      default: () => [] as types.PageItem[],
    },
  },
  emits: ['page-changed'],
  data() {
    return {
      T,
    };
  },
});
